export const classConfig = {
	toast: "w-full flex items-center gap-3 p-4 bg-white rounded-xl border border-gray-100 shadow-md",
	title: "text-sm! font-medium!",
	description: "text-sm!",
	success: "bg-green-700! border-green-900!",
	error: "bg-red-700! border-red-900!",
	warning: "bg-yellow-700! border-yellow-900!",
	info: "bg-blue-700! border-blue-900!",
};
